export type NavBannerStatus = 'active' | 'inactive';

export interface NavBannerDefinition {
  id: string;
  status: NavBannerStatus;
  href: string;
  messageKey: string;
  mobileMessageKey?: string;
  ctaKey: string;
  mobileCtaKey?: string;
  dismissKey: string;
}

export interface NavBannerContent {
  id: string;
  href: string;
  message: string;
  mobileMessage: string;
  ctaLabel: string;
  mobileCtaLabel: string;
  dismissLabel: string;
}

export const NAV_BANNER_REGISTRY: readonly NavBannerDefinition[] = [
  {
    id: 'music-waitlist',
    status: 'active',
    href: '/music/register',
    messageKey: 'nav.musicPromo.desktop',
    mobileMessageKey: 'nav.musicPromo.mobile',
    ctaKey: 'nav.musicPromo.joinWaitlist',
    mobileCtaKey: 'nav.musicPromo.join',
    dismissKey: 'nav.musicPromo.dismiss',
  },
] as const;

export function getActiveNavBanners(t: (key: string) => string): NavBannerContent[] {
  return NAV_BANNER_REGISTRY.filter((banner) => banner.status === 'active').map((banner) => ({
    id: banner.id,
    href: banner.href,
    message: t(banner.messageKey),
    mobileMessage: t(banner.mobileMessageKey ?? banner.messageKey),
    ctaLabel: t(banner.ctaKey),
    mobileCtaLabel: t(banner.mobileCtaKey ?? banner.ctaKey),
    dismissLabel: t(banner.dismissKey),
  }));
}
